import 'bootstrap/dist/css/bootstrap.min.css';
import '../sass/_bootstrap.scss';

import { createApp } from 'vue';
import router from './router';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import '@mdi/font/css/materialdesignicons.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular } from '@fortawesome/free-regular-svg-icons';

import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

library.add(fas);
library.add(faCircleRegular);

const app = createApp({});
app.use(router);
app.component('fa', FontAwesomeIcon);
app.component('faLayer', FontAwesomeLayers);
app.component('faLayerText', FontAwesomeLayersText);
app.mount('#app');

(window as any).Pusher = Pusher;
//soketi
(window as any).Echo = new Echo({
  broadcaster: 'pusher',
  key: (window as any).Laravel.mix.PUSHER_APP_KEY,
  wsHost: (window as any).Laravel.mix.PUSHER_BROWSER_HOST,
  wsPort: (window as any).Laravel.mix.PUSHER_BROWSER_PORT,
  wssPort: (window as any).Laravel.mix.PUSHER_BROWSER_PORT,
  forceTLS: false,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
});

// app.config.errorHandler = (err, vm, info) => {
//   let errorMessage = 'エラーが発生しました。トップページに移動しますか？\n\n';
//   errorMessage += '[エラー内容]\n' + err + '\n';
//   errorMessage += '[Info]\n' + info + '\n';
//   if (confirm(errorMessage)) {
//     location.href = '/';
//   }
// };
